import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

window.customElements.define('ds-footer', wrap(Vue, () => import('~root/src/components/navigation/footer/Footer.vue?shadow')))

window.customElements.define('ds-multi-checkbox', wrap(Vue, () => import('~root/src/components/forms/checkbox/multiCheckbox/MultiCheckbox.vue?shadow')))

window.customElements.define('ds-checkbox', wrap(Vue, () => import('~root/src/components/forms/checkbox/checkbox/Checkbox.vue?shadow')))

window.customElements.define('ds-carousel', wrap(Vue, () => import('~root/src/components/carousel/Carousel.vue?shadow')))

window.customElements.define('ds-carousel-item', wrap(Vue, () => import('~root/src/components/carousel/carousel-item/CarouselItem.vue?shadow')))

window.customElements.define('ds-tooltip', wrap(Vue, () => import('~root/src/components/tooltip/Tooltip.vue?shadow')))

window.customElements.define('ds-modal', wrap(Vue, () => import('~root/src/components/modal/Modal.vue?shadow')))

window.customElements.define('ds-link', wrap(Vue, () => import('~root/src/components/link/Link.vue?shadow')))

window.customElements.define('ds-hero', wrap(Vue, () => import('~root/src/components/hero/Hero.vue?shadow')))

window.customElements.define('ds-ribbon', wrap(Vue, () => import('~root/src/components/ribbon/Ribbon.vue?shadow')))

window.customElements.define('ds-ribbon-item', wrap(Vue, () => import('~root/src/components/ribbon/ribbon-item/RibbonItem.vue?shadow')))

window.customElements.define('ds-auto-suggest', wrap(Vue, () => import('~root/src/components/forms/autoSuggest/autoSuggest/AutoSuggest.vue?shadow')))

window.customElements.define('ds-accordion', wrap(Vue, () => import('~root/src/components/accordion/Accordion.vue?shadow')))

window.customElements.define('ds-accordion-item', wrap(Vue, () => import('~root/src/components/accordion/accordion-item/AccordionItem.vue?shadow')))

window.customElements.define('ds-search', wrap(Vue, () => import('~root/src/components/forms/search/search/Search.vue?shadow')))

window.customElements.define('ds-date-picker', wrap(Vue, () => import('~root/src/components/forms/datePicker/DatePicker.vue?shadow')))

window.customElements.define('ds-video-modal', wrap(Vue, () => import('~root/src/components/videoModal/VideoModal.vue?shadow')))

window.customElements.define('ds-inline-alert', wrap(Vue, () => import('~root/src/components/inlineAlert/InlineAlert.vue?shadow')))

window.customElements.define('ds-app-alert', wrap(Vue, () => import('~root/src/components/appAlert/AppAlert.vue?shadow')))

window.customElements.define('ds-form', wrap(Vue, () => import('~root/src/components/forms/form/Form.vue?shadow')))

window.customElements.define('ds-input', wrap(Vue, () => import('~root/src/components/forms/input/Input.vue?shadow')))